import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen } from '../../redux/userInfo';
import { open, close, listupdater, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import CutomerDetailPop from '../../component/CutomerDetailPop';

import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';
import Contractwrite from '../../component/Contractwrite';

import * as APIS from "../../utils/service";
import { getMemberinfo, hpHypen, numFormat, useIntersectionObserver } from "../../utils/utils";
import ProductOutSimplewrite from '../../component/ProductOutSimplewrite';
import CustomerOutWrite from '../../component/CustomerOutWrite';
import { calcLength } from 'framer-motion';


export default function Outsidelist({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const target = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);

    const { listupdate } = useSelector(s => s.popupReducer);

    let statusArrs = [];
    configdata?.consts?.contractStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 99){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    const statusName = statusArrs;

    
    const [selectorderby, setselectorderby] = useState('0');   
    const [contractIdx, setcontractIdx] = useState(null);   
    
    const [detailwrite, setdetailwrite] = useState(false);   
    const [stype, setstype] = useState('미니홈매물의뢰');   
    
    
    const [productlistTh, setproductlistTh] = useState([
        {key: 'create_dt', viewernames: '접수일', winsize: 160}, 
        {key: 'sell_type', viewernames: '거래형태', winsize: 100},
        {key: 'category_2', viewernames: '매물종류', winsize: 120},
        {key: 'addr', viewernames: '소재지(희망지역)', winsize: 500},
        {key: 'price', viewernames: '가격', winsize: 180},
        {key: 'area_supply', viewernames: '면적(전용,연)', winsize: 120},
        {key: 'client_hp', viewernames: '연락처', winsize: 160}, 
        {key: 'double', viewernames: '중복여부'}, 
        {key: 'sendstatys', viewernames: '접수여부'}, 
        {key: 'etc', viewernames: '비고'}, 
        {key: 'easybutton', viewernames: '삭제', winsize: 120 },
    ]);   
    const [simplewrite, setsimplewrite] = useState(false); 
    const [simplewrite2, setsimplewrite2] = useState(false); 
    
    const [productlistTd, setproductlistTd] = useState([]);   
    const [saveproductlistTd, setsaveproductlistTd] = useState([]);   
    const [row, setrow] = useState({}); 
    const [listDataAll, setlistDataAll] = useState([]); 
    const [memberinfos, setmemberinfos] = useState(''); 
    const [itemCounts, setitemCounts] = useState(0); 

    const [page, setPage] = useState(0);
    const bpmviewCounts = configdata?.bpmviewCount;
    //검색 텍스트
    const [searchTxt ,setsearchTxt] = useState("");

    useEffect(() => {
        getMemberinfo(setmemberinfos);
    }, []);
    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });
    useEffect(() => {
        let sender = {}
        APIS.postData('/v1/item/list', sender).then(({ data }) => {
            //console.log("data !!!!: ", data?.list?.length);
            setitemCounts(data?.list?.length);
        }).catch(({ response }) => {
        }).finally(() => {
        });     
    }, []);

    useEffect(() => {
        if(listupdate === true){
            dispatch(listupdater({ listupdate: false }));
            listopen();
        }
    }, [listupdate]);    

    useEffect(() => {
        if(memberinfos){
            listopen();
            setPage(1);
            setproductlistTd([]);
            observe(target.current);
        }
        let thSettings = [
            {key: 'create_dt', viewernames: '접수일', winsize: 160}, 
            {key: 'sell_type', viewernames: '거래형태', winsize: 100},
            {key: 'category_2', viewernames: '매물종류', winsize: 120},
            {key: 'addr', viewernames: '소재지(희망지역)', winsize: 500},
            {key: 'price', viewernames: '가격', winsize: 180},
            {key: 'area_supply', viewernames: '면적(전용,연)', winsize: 120},
            {key: 'client_hp', viewernames: '연락처', winsize: 160}, 
        ];
        if(stype === '발품맨 고객의뢰'){
            thSettings.push({key: 'posCounts', viewernames: '접수가능수'});
            thSettings.push({key: 'orderCounts', viewernames: '접수 수'});
            thSettings.push({key: 'etc', viewernames: '비고'});
        } else {
            thSettings.push({key: 'double', viewernames: '중복여부'});
            thSettings.push({key: 'sendstatys', viewernames: '접수여부'});
            thSettings.push({key: 'etc', viewernames: '비고'});
            thSettings.push({key: 'easybutton', viewernames: '삭제', winsize: 120 });
        }

        setproductlistTh(thSettings);

    }, [stype]);
    useEffect(() => {
        if(memberinfos){
            listopen();
            setPage(1);
            setproductlistTd([]);
            observe(target.current);
        }
    }, [productlistTh, memberinfos]);
    const listopen = () => {
        let stypes = stype || '미니홈매물의뢰';
        dispatch(loadingflas({ loading: true }));
        let sender = {
            rolling: false,
            stypes: stypes
        }
        console.log(sender);
        if(stypes === "미니홈매물의뢰"){
            APIS.postData('/v1/item/oustsideminiitemlist', sender).then(({ data }) => {
                if(data){
                    //console.log(data);
                    let lists = data?.list;
                    let itemlists = data?.itemlist;
                    let tdlist = [];
                    let now = moment(new Date());
                    
                    setlistDataAll(lists);

                    lists?.map((x, i) => {
                        //let productCode = ('0000000'+x?.idx).slice(-7);
                        let productCode = x?.idx;
                        let pushData = {};
                        
                        if(x?.addr !== ''){
                            productlistTh?.map((x2, i2) => {
                                if(x2?.key === 'status'){
                                    pushData[x2?.key] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.arrays; //0:명칭, 1: 색상, 2: select 여부 y or no
                                    pushData['statusname'] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.title;
                                } else if(x2?.key === 'building_dong_floor_all'){
                                    pushData[x2?.key] = x[x2?.key]+"동"; //
                                } else if(x2?.key === 'building_floor'){
                                    pushData[x2?.key] = x[x2?.key]+"층"; //
                                } else if(x2?.key === 'building_unit'){
                                    pushData[x2?.key] = x[x2?.key]+"호"; //
                                } else if(x2?.key === 'category_2'){
                                    pushData[x2?.key] = configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx*1 === x['category_2']*1))?.title;
                                } else if(x2?.key === 'price'){
                                    if(x?.sell_type === '월세'){
                                        pushData[x2?.key] = `${numFormat(x?.price_all)}/${numFormat(x?.price_month)}만원`; //
                                    } else if(x?.sell_type === '전세'){
                                        pushData[x2?.key] = `${numFormat(x?.price_all)}만원`; //
                                    } else {
                                        pushData[x2?.key] = `${numFormat(x?.price_sell)}만원`; //
                                    }
                                } else if(x2?.key === 'price_sell'){
                                    pushData[x2?.key] = numFormat(x[x2?.key]); //
                                } else if(x2?.key === 'client_hp'){
                                    pushData[x2?.key] = hpHypen(x[x2?.key]); //
                                } else if(x2?.key === 'double'){
                                    //pushData[x2?.key] = itemlists?.filter(item => item?.miniIdx*1 === x?.idx)?.length > 0 ? '중복' : '-'; //
                                    pushData[x2?.key] = '-'; //
                                } else if(x2?.key === 'sendstatys'){
                                    let findItem = itemlists?.find(item => item?.miniIdx*1 === x?.idx);
                                    pushData[x2?.key] = findItem ? '접수' : '-'; //
                                    pushData["itemidx"] = findItem ? findItem.idx : null
                                    // pushData[x2?.key] = itemlists?.filter(item => item?.miniIdx*1 === x?.idx)?.length > 0 ? '접수' : '-'; //
                                } else if(x2?.key === 'create_dt'){
                                    pushData[x2?.key] = moment(x[x2?.key]).format('YYYY-MM-DD HH:mm') //
                                } else if(x2?.key === 'area_supply'){
                                    if(x?.category_1*1 === 3){
                                        pushData[x2?.key] = x?.area_floor+'㎡'; //연면적
                                        //pushData[x2?.key] = '-'; //연면적
                                    } else {
                                        pushData[x2?.key] = x?.area_private+'㎡'; //전용면적
                                    }
                                } else {
                                    pushData[x2?.key] = x[x2?.key];
                                }
                            });
                            //console.log(pushData);
                            pushData['ordercreatedt'] = moment(x['create_dt']).format('YYYYMMDD')*1;
                            pushData['orderprice_sell'] = x['price_sell']*1;
                            pushData['orderarea_private'] = x['area_private']*1;
                            pushData['category_1'] = x['category_1']*1;
                            pushData['idx'] = x['idx']*1;
                            pushData['lat'] = x['lat']*1;
                            pushData['lng'] = x['lng']*1;
                            pushData['damdangidx'] = x?.user?.idx;
                            pushData['sigungu'] = x?.sigungu?.replace(' 전체','');
                            pushData['dong'] = x?.dong;
                            tdlist.push(pushData);
                        }
                    })
                    
                    setproductlistTd(tdlist);
                    setsaveproductlistTd(data);
                    //searchSetlist();
                    // console.log(tdlist);
                }
            }).catch(({ response }) => {
                const { data } = response;
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });   
        } else if(stypes === "미니홈고객의뢰"){
            APIS.postData('/v1/item/oustsideminicustomerlist', sender).then(({ data }) => {
                if(data){
                    console.log(data);
                    let lists = data?.list;
                    let itemlists = data?.itemlist;
                    let tdlist = [];
                    let now = moment(new Date());
                    
                    setlistDataAll(lists);
                    lists?.map((x, i) => {
                        //let productCode = ('0000000'+x?.idx).slice(-7);
                        let productCode = x?.idx;
                        let pushData = {};
                        
                            productlistTh?.map((x2, i2) => {
                                if(x2?.key === 'status'){
                                    pushData[x2?.key] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.arrays; //0:명칭, 1: 색상, 2: select 여부 y or no
                                    pushData['statusname'] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.title;
                                } else if (x2?.key === 'addr'){
                                    if(x?.citys?.length > 1){
                                        if(x?.citys[0]?.polygon){
                                            pushData[x2?.key] = '폴리곤설정 외 '+x?.citys?.length;
                                        } else {
                                            pushData[x2?.key] = `${x?.citys[0]?.sido} ${x?.citys[0]?.sigungu} ${x?.citys[0]?.dong} 외 ${x?.citys?.length}`;
                                        }
                                    } else {
                                        if(x?.citys[0]?.polygon){
                                            pushData[x2?.key] = '폴리곤설정';
                                        } else {
                                            pushData[x2?.key] = `${x?.citys[0]?.sido} ${x?.citys[0]?.sigungu} ${x?.citys[0]?.dong}`;
                                        }
                                    }                                    
                                } else if(x2?.key === 'building_dong_floor_all'){
                                    pushData[x2?.key] = x[x2?.key]+"동"; //
                                } else if(x2?.key === 'building_floor'){
                                    pushData[x2?.key] = x[x2?.key]+"층"; //
                                } else if(x2?.key === 'building_unit'){
                                    pushData[x2?.key] = x[x2?.key]+"호"; //
                                } else if(x2?.key === 'category_2'){
                                    pushData[x2?.key] = configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx*1 === x['category_2']*1))?.title;
                                } else if(x2?.key === 'price'){
                                    if(x?.sell_type === '월세'){
                                        //pushData[x2?.key] = numFormat(x[x2?.key])+"~"+numFormat(x['price_all_max']);
                                        pushData[x2?.key] = numFormat(x['price_all_min'])+"~"+numFormat(x['price_all_max'])+"\n/ "+numFormat(x['price_month_min'])+"~"+numFormat(x['price_month_max']);
                                    } else {
                                        pushData[x2?.key] = numFormat(x['price_all_min'])+"~"+numFormat(x['price_all_max']);
                                        //pushData[x2?.key] = numFormat(x[x2?.key])+"/"+numFormat(x['price_month_min'])+"~"+numFormat(x['price_month_max']);
                                    }
                                } else if(x2?.key === 'price_sell'){
                                    pushData[x2?.key] = numFormat(x[x2?.key]); //
                                } else if(x2?.key === 'client_hp'){
                                    pushData[x2?.key] = hpHypen(x['hp']); //
                                } else if(x2?.key === 'double'){
                                    //pushData[x2?.key] = itemlists?.filter(item => item?.miniIdx*1 === x?.idx)?.length > 0 ? '중복' : '-'; //
                                    pushData[x2?.key] = '-'; //
                                } else if(x2?.key === 'sendstatys'){
                                    pushData[x2?.key] = itemlists?.filter(item => item?.miniIdx*1 === x?.idx)?.length > 0 ? '접수' : '-'; //
                                } else if(x2?.key === 'area_supply'){
                                    pushData[x2?.key] = x['item_area_min']+"㎡~"+x['item_area_max']+'㎡';
                                } else if(x2?.key === 'create_dt'){
                                    pushData[x2?.key] = moment(x[x2?.key]).format('YYYY-MM-DD HH:mm') //
                                } else {
                                    pushData[x2?.key] = x[x2?.key];
                                }
                            });
                            //console.log(pushData);
                            pushData['ordercreatedt'] = moment(x['create_dt']).format('YYYYMMDD')*1;
                            pushData['orderprice_sell'] = x['price_sell']*1;
                            pushData['orderarea_private'] = x['area_private']*1;
                            pushData['category_1'] = x['category_1']*1;
                            pushData['idx'] = x['idx']*1;
                            pushData['lat'] = x['lat']*1;
                            pushData['lng'] = x['lng']*1;
                            pushData['damdangidx'] = x?.user?.idx;
                            // pushData['sigungu'] = x?.sigungu?.replace('전체','');
                            // pushData['dong'] = x?.dong;
                            tdlist.push(pushData);
                    })
                    
                    setproductlistTd(tdlist);
                    setsaveproductlistTd(data);
                    //searchSetlist();
                    //console.log(tdlist);
                }
            }).catch(({ response }) => {
                const { data } = response;
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });   
        } else if(stypes === "발품맨 고객의뢰"){
            APIS.postData('/v1/item/bpmcustomerlist', sender).then(({ data }) => {
                if(data){
                    console.log(data);
                    let lists = data?.list;
                    let itemlists = data?.itemlist;
                    let alllists = data?.alllist;
                    let tdlist = [];
                    let now = moment(new Date());
                    
                    setlistDataAll(lists);
                    lists?.map((x, i) => {
                        //let productCode = ('0000000'+x?.idx).slice(-7);
                        let productCode = x?.idx;
                        let pushData = {};
                        
                        // let diffmyfamilly =  alllists?.filter(item => item?.bpmIdx*1 === x?.idx*1 && item?.c_idx === memberinfos?.c_idx)?.length; //
                        // let myorders =  alllists?.filter(item => item?.bpmIdx*1 === x?.idx*1 && item?.u_idx === memberinfos?.idx)?.length; //
                        // if(diffmyfamilly > 0 || myorders > 0 ){
                        //     return;
                        // }

                        productlistTh?.map((x2, i2) => {
                            if(x2?.key === 'status'){
                                pushData[x2?.key] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.arrays; //0:명칭, 1: 색상, 2: select 여부 y or no
                                pushData['statusname'] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.title;
                            } else if (x2?.key === 'addr'){
                                if(x?.citys?.length > 1){
                                    if(x?.citys[0]?.polygon){
                                        pushData[x2?.key] = '폴리곤설정 외 '+x?.citys?.length;
                                    } else {
                                        pushData[x2?.key] = `${x?.citys[0]?.sido} ${x?.citys[0]?.sigungu} ${x?.citys[0]?.dong} 외 ${x?.citys?.length}`;
                                    }
                                } else {
                                    if(x?.citys[0]?.polygon){
                                        pushData[x2?.key] = '폴리곤설정';
                                    } else {
                                        pushData[x2?.key] = `${x?.citys[0]?.sido} ${x?.citys[0]?.sigungu} ${x?.citys[0]?.dong}`;
                                    }
                                }                                    
                            } else if(x2?.key === 'building_dong_floor_all'){
                                pushData[x2?.key] = x[x2?.key]+"동"; //
                            } else if(x2?.key === 'building_floor'){
                                pushData[x2?.key] = x[x2?.key]+"층"; //
                            } else if(x2?.key === 'building_unit'){
                                pushData[x2?.key] = x[x2?.key]+"호"; //
                            } else if(x2?.key === 'category_2'){
                                pushData[x2?.key] = configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx*1 === x['category_2']*1))?.title;
                            } else if(x2?.key === 'price'){
                                if(x?.sell_type === '월세'){
                                    //pushData[x2?.key] = numFormat(x[x2?.key])+"~"+numFormat(x['price_all_max']);
                                    pushData[x2?.key] = numFormat(x['price_all_min'])+"~"+numFormat(x['price_all_max'])+"\n/ "+numFormat(x['price_month_min'])+"~"+numFormat(x['price_month_max']);
                                } else {
                                    pushData[x2?.key] = numFormat(x['price_all_min'])+"~"+numFormat(x['price_all_max']);
                                    //pushData[x2?.key] = numFormat(x[x2?.key])+"/"+numFormat(x['price_month_min'])+"~"+numFormat(x['price_month_max']);
                                }
                            } else if(x2?.key === 'price_sell'){
                                pushData[x2?.key] = numFormat(x[x2?.key]); //
                            } else if(x2?.key === 'client_hp'){
                                pushData[x2?.key] = hpHypen(x['hp']); //
                            } else if(x2?.key === 'double'){
                                pushData[x2?.key] = '-'; //
                            } else if(x2?.key === 'posCounts'){
                                pushData[x2?.key] = x['maxCounts']+"건"; //
                            } else if(x2?.key === 'orderCounts'){
                                pushData[x2?.key] = alllists?.filter(item => item?.bpmIdx*1 === x?.idx*1)?.length+"건"; //
                            } else if(x2?.key === 'area_supply'){
                                pushData[x2?.key] = x['item_area_min']+"㎡~"+x['item_area_max']+'㎡';
                            } else if(x2?.key === 'create_dt'){
                                pushData[x2?.key] = moment(x[x2?.key]).format('YYYY-MM-DD HH:mm') //
                            } else {
                                pushData[x2?.key] = x[x2?.key];
                            }
                        });
                        //console.log(pushData);
                        pushData['ordercreatedt'] = moment(x['create_dt']).format('YYYYMMDD')*1;
                        pushData['orderprice_sell'] = x['price_sell']*1;
                        pushData['orderarea_private'] = x['area_private']*1;
                        pushData['category_1'] = x['category_1']*1;
                        pushData['idx'] = x['idx']*1;
                        pushData['lat'] = x['lat']*1;
                        pushData['lng'] = x['lng']*1;
                        pushData['damdangidx'] = x?.user?.idx;
                        // pushData['sigungu'] = x?.sigungu?.replace('전체','');
                        // pushData['dong'] = x?.dong;
                        tdlist.push(pushData);
                    })
                    
                    setproductlistTd(tdlist);
                    setsaveproductlistTd(data);
                    //searchSetlist();
                    //console.log(tdlist);
                }
            }).catch(({ response }) => {
                const { data } = response;
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });   
        } else {
            APIS.postData('/v1/item/oustsidelist', sender).then(({ data }) => {
                if(data){
                    
                    let tdlist = [];
                    let now = moment(new Date());
                    
                    data?.map((x, i) => {
                        //let productCode = ('0000000'+x?.idx).slice(-7);
                        let productCode = x?.idx;
                        

                        let pushData = {};
                        
                        // let pushData = {
                        //     '상태': ['간편', 'orange', 'no'], '매물번호': productCode, '접수일': moment(x?.create_dt).format('YY/MM/DD'), 
                        //     '확인일': parseInt(days) + '일 전', '읍/면,동': x?.dong, '지번': x?.jibun, '전용': x?.area_private+"㎡", '종류': x?.sell_type, 
                        //     '가격': numFormat(x?.price_sell), '관리비': numFormat(x?.price_maintenance) 
                        // }
                        if(x?.addr !== ''){
                            productlistTh?.map((x2, i2) => {
                                if(x2?.key === 'status'){
                                    pushData[x2?.key] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.arrays; //0:명칭, 1: 색상, 2: select 여부 y or no
                                    pushData['statusname'] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.title;
                                } else if(x2?.key === 'building_dong_floor_all'){
                                    pushData[x2?.key] = x[x2?.key]+"동"; //
                                } else if(x2?.key === 'building_floor'){
                                    pushData[x2?.key] = x[x2?.key]+"층"; //
                                } else if(x2?.key === 'building_unit'){
                                    pushData[x2?.key] = x[x2?.key]+"호"; //
                                } else if(x2?.key === 'category_2'){
                                    pushData[x2?.key] = configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx*1 === x['category_2']*1))?.title;
                                } else if(x2?.key === 'price'){
                                    if(x?.sell_type === '월세'){
                                        pushData[x2?.key] = `${numFormat(x?.price_all)}/${numFormat(x?.price_month)}`; //
                                    } else if(x?.sell_type === '전세'){
                                        pushData[x2?.key] = `${numFormat(x?.price_all)}`; //
                                    } else {
                                        pushData[x2?.key] = `${numFormat(x?.price_sell)}만원`; //
                                    }
                                } else if(x2?.key === 'price_sell'){
                                    pushData[x2?.key] = numFormat(x[x2?.key]); //
                                } else {
                                    pushData[x2?.key] = x[x2?.key];
                                }
                            });
                            //console.log(pushData);
                            pushData['ordercreatedt'] = moment(x['create_dt']).format('YYYYMMDD')*1;
                            pushData['orderprice_sell'] = x['price_sell']*1;
                            pushData['orderarea_private'] = x['area_private']*1;
                            pushData['category_1'] = x['category_1']*1;
                            pushData['idx'] = x['idx']*1;
                            pushData['lat'] = x['lat']*1;
                            pushData['lng'] = x['lng']*1;
                            pushData['damdangidx'] = x?.user?.idx;
                            tdlist.push(pushData);
                        }
                        
                        
                    })
                    
                    setproductlistTd(tdlist);
                    setsaveproductlistTd(data);
                    //searchSetlist();
                    console.log(tdlist);
                }
            }).catch(({ response }) => {
                const { data } = response;
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });     
        }      
    }

    const itemDelete = (idx = 0, tables = '') => {
        let sender = {
            idx: idx,
            tables: tables
        }
        APIS.postData('/v1/item/Outremove', sender).then(({ data }) => {
            dispatch(close());
            listopen();
            dispatch(
                open({
                    component: '삭제되었습니다.',
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(close());
                    }
                })
            );   
        }).catch(({ response }) => {
            const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });  

    }

    const filterFunc = ( v, i ) => {
        if(searchTxt){
            return v?.addr?.includes(searchTxt)
        }
        return true
    }

    return(
        <>
        {simplewrite === true && <ProductOutSimplewrite setsimplewrite={setsimplewrite} row={row} /> }
        {simplewrite2 === true && <CustomerOutWrite setdetailwrite={setsimplewrite2} row={row} stypes={stype} /> }
        <Layout header={false} actives={'5'} footters={false}>

            <div
                style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden'}}
                className='padding40'
            >
                <div
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}
                >
                    <span className='bolds fontsize24'>의뢰매물</span>
                </div>
                
                <div style={{ width: 'calc(50% - 40px)', gap: 5, display: 'flex', marginTop: 10}}>
                    <Button buttonTxt={'미니홈매물의뢰'} className={`searchbutton ${stype === '미니홈매물의뢰' ? 'active' : ''}`}
                        styles={{ width: 150 }}
                        onPress={() => {
                            setstype('미니홈매물의뢰') 
                        }} 
                    />
                    <Button buttonTxt={'미니홈고객의뢰'} className={`searchbutton ${stype === '미니홈고객의뢰' ? 'active' : ''}`}
                        styles={{ width: 150 }}
                        onPress={() => {
                            setstype('미니홈고객의뢰') 
                        }} 
                    />
                    <Button styles={{ width: 150 }} buttonTxt={'점포거래소 매물의뢰'} className={`searchbutton ${stype === '점포거래소' ? 'active' : ''}`} onPress={() => {
                        //setstype('점포거래소') 
                        dispatch(
                            open({
                                component: `준비중입니다.`,
                                title: '알림',
                                titleviewer: true,
                                alert: false,
                                button: "확인",
                                onPress: () => {
                                    dispatch(close());
                                }
                            })
                        );  
                    }} />
                    <Button styles={{ width: 150 }} buttonTxt={'발품맨 고객의뢰'} className={`searchbutton ${stype === '발품맨 고객의뢰' ? 'active' : ''}`} onPress={() => {
                        dispatch(
                            open({
                                component: `준비중입니다.`,
                                title: '알림',
                                titleviewer: true,
                                alert: false,
                                button: "확인",
                                onPress: () => {
                                    dispatch(close());
                                }
                            })
                        );  
                        return;
                        if(memberinfos?.email === 'kdhlove789@nate.com'){
                            setstype('발품맨 고객의뢰');
                            return;
                        }
                        if(itemCounts >= bpmviewCounts){
                            setstype('발품맨 고객의뢰');
                        } else {
                            dispatch(
                                open({
                                    component: `매물을 30개 이상 등록해야\n의뢰 목록을 확인할 수 있습니다.`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        dispatch(close());
                                    }
                                })
                            );  
                        }
                    }} />                     
                </div>
                <div 
                    style={{ width: '100%', height: 'calc(100% - 96px)' }}
                    className='productlistArea'
                >
                    <div style={{display:"flex", justifyContent:"end", paddingBottom:10}}>
                        <div style={{ width:300 }}>
                            <Input 
                                className={`inputs`}
                                placeholder="소재지"
                                setValue={setsearchTxt}
                                value={searchTxt}
                                name="mb_phone"
                                allwaysclearflag={true}
                                searchicons={true}
                                style={{
                                    paddingLeft: 35
                                }}
                            />   
                        </div>
                    </div>
                    
                    <div className="productlist_th">
                        {productlistTh?.length > 0 && productlistTh?.map((x,i) => {
                            return (
                                <div 
                                    key={i}
                                    style={{ minWidth: x?.winsize ? x?.winsize : 76 }}
                                >
                                    <div style={{ whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 12 }}>
                                        {(x?.key === 'area_supply' && stype === '미니홈고객의뢰') ? '면적(희망)':x?.viewernames}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className='product_scroll_list' style={{ height: "calc(100% - 60px)"}}>
                        {productlistTd?.length > 0 && productlistTd?.filter(filterFunc)?.map((x,i) => {
                            // console.log(x);
                            let listClass = "";
                            let listviewer = false;
                            // if(i > (page*10)){
                            //     return;
                            // }
                            if(stype === '미니홈매물의뢰'){
                                let addresCker = memberinfos?.compony?.miniordersteps;
                                let jsonAddrs = [];
                                if(addresCker !== ''){
                                    jsonAddrs = JSON.parse(addresCker);
                                }
                                let addrs = jsonAddrs?.find(item => item?.userIdx*1 === memberinfos?.idx*1)?.areas?.map(item2 => item2?.viewernames?.replace(' 전체',''));
                                //console.log(addrs, x?.sigungu, x?.dong);
                                if(addrs?.length > 0){
                                    if(addrs?.includes(x?.sigungu) || addrs?.includes(x?.dong)){
                                        listviewer = true;
                                    }
                                    if(!listviewer){
                                        console.log("???",addrs)
                                        return;
                                    }
                                }
                            }
 

                            return (
                                <div 
                                    key={i}
                                    className={`productlist_td ${x['sendstatys'] === '접수' && 'doubleCker'}`}
                                    style={{
                                        cursor: 'pointer',
                                    }}
                                    onDoubleClick={() => {
                                        if(x['sendstatys'] === '접수'){
                                            dispatch(
                                                open({
                                                    component: `이미 접수한 ${stype === '미니홈고객의뢰' ? '고객' : '매물'}입니다.${x?.itemidx ? " (매물번호:"+x?.itemidx+")":""}`,
                                                    title: '알림',
                                                    button: "확인",
                                                    titleviewer: true,                 
                                                    alert: false,
                                                    onPress: () => {
                                                        dispatch(close());
                                                    },
                                                })
                                            );   
                                            return;
                                        }
                                        setrow(listDataAll?.find(item => item?.idx*1 === x?.idx*1));
                                        if(stype === '미니홈고객의뢰' || stype === '발품맨 고객의뢰'){
                                            if(stype === '발품맨 고객의뢰'){
                                                let sender = {
                                                    rolling: false,
                                                    stypes: '발품맨 고객의뢰'
                                                }
                                                APIS.postData('/v1/item/bpmcustomerlist', sender).then(({ data }) => {
                                                    if(data){
                                                        let datas = data?.list?.find(item => item?.idx*1 === x?.idx*1);
                                                        let orderCounts =  data?.alllist?.filter(item => item?.bpmIdx*1 === x?.idx*1)?.length; //
                                                        let diffmyfamilly =  data?.alllist?.filter(item => item?.bpmIdx*1 === x?.idx*1 && item?.c_idx === memberinfos?.c_idx)?.length; //
                                                        let myorders =  data?.alllist?.filter(item => item?.bpmIdx*1 === x?.idx*1 && item?.u_idx === memberinfos?.idx)?.length; //
                                                        if(myorders > 0){
                                                            dispatch(
                                                                open({
                                                                    component: `이미 등록한 고객입니다.`,
                                                                    title: '알림',
                                                                    button: "확인",
                                                                    titleviewer: true,                 
                                                                    alert: false,
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                    },
                                                                })
                                                            );   
                                                            return;
                                                        }
                                                        if(diffmyfamilly > 0){
                                                            dispatch(
                                                                open({
                                                                    component: `다른 직원이 이미 등록한 고객입니다.`,
                                                                    title: '알림',
                                                                    button: "확인",
                                                                    titleviewer: true,                 
                                                                    alert: false,
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                    },
                                                                })
                                                            );   
                                                            return;
                                                        }
                                                        if(orderCounts >= datas?.maxCounts*1){
                                                            dispatch(
                                                                open({
                                                                    component: `더이상 접수 하실 수 없습니다.`,
                                                                    title: '알림',
                                                                    button: "확인",
                                                                    titleviewer: true,                 
                                                                    alert: false,
                                                                    onPress: () => {
                                                                        dispatch(close());
                                                                    },
                                                                })
                                                            );   
                                                            return;
                                                        } else {
                                                            setsimplewrite2(true);
                                                        }
                                                    }
                                                }).catch(({ response }) => {
                                                    const { data } = response;
                                                }).finally(() => {
                                                    dispatch(loadingflas({ loading: false }));
                                                });   
                                            } else {
                                                setsimplewrite2(true);
                                            }
                                        } else {
                                            setsimplewrite(true);
                                        }
                                    }}                                   
                                >
                                {productlistTh?.length > 0 && productlistTh?.map((x2,i2) => {
                                    
                                    return (
                                        <div 
                                            key={i2}
                                            style={{ minWidth: x2?.winsize ? x2?.winsize : 76 }}
                                        >
                                            {x2?.key === 'easybutton' ? 
                                            <div 
                                                className={`${listClass}`}
                                            >
                                                <Button
                                                    onPress={() => {
                                                        // dispatch(
                                                        //     open({
                                                        //         component: '간편등록하시겠습니까?',
                                                        //         title: '알림',
                                                        //         button: "등록",
                                                        //         buttonCencle: "닫기",     
                                                        //         titleviewer: true,          
                                                        //         alert: false,
                                                        //         onPress: () => {
                                                        //             let sender = saveproductlistTd?.find(item => item?.idx === x?.idx);
                                                        //             sender.idx = '';
                                                        //             sender.easy = true;
                                                        //             console.log(sender);
                                                        //             //return;
                                                        //             //dispatch(loadingflas({ loading: true }));
                                                        //             APIS.postData('/v1/item/insert', sender).then(({ data }) => {
                                                        //                 if(data){
                                                        //                     dispatch(close());
                                                        //                     listopen();
                                                        //                     dispatch(
                                                        //                         open({
                                                        //                             component: '매물이 등록되었습니다.',
                                                        //                             title: '알림',
                                                        //                             titleviewer: true,
                                                        //                             alert: false,
                                                        //                             button: "확인",
                                                        //                             onPress: () => {
                                                        //                                 dispatch(close());
                                                        //                             }
                                                        //                         })
                                                        //                     );   
                                                        //                 }
                                                        //             }).catch(({ response }) => {
                                                        //                 const { data } = response;
                                                        //                 console.log(response);
                                                        //                 dispatch(
                                                        //                     open({
                                                        //                         component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                        //                         title: '알림',
                                                        //                         button: "확인",
                                                        //                         titleviewer: true,                 
                                                        //                         alert: false,
                                                        //                         onPress: () => {
                                                        //                             dispatch(close());
                                                        //                         },
                                                        //                     })
                                                        //                 );   
                                                        //             }).finally(() => {
                                                        //                 //dispatch(loadingflas({ loading: false }));
                                                        //             });     
                                                        //         },
                                                        //         onCancelPress: () => {
                                                        //             dispatch(close());
                                                        //         },
                                                        //     })
                                                        // );    
                                                        
                                                        dispatch(
                                                            open({
                                                                component: '삭제하시겠습니까?',
                                                                title: '알림',
                                                                button: "삭제",
                                                                buttonCencle: "닫기",     
                                                                titleviewer: true,          
                                                                alert: false,
                                                                onPress: () => {
                                                                    if(stype == "미니홈매물의뢰"){
                                                                        itemDelete(x?.idx, 'ITEM_MINI_TB');
                                                                    }
                                                                    if(stype == "미니홈고객의뢰"){
                                                                        itemDelete(x?.idx, 'CUSTOMER_MINI_TB');
                                                                    }
                                                                },
                                                                onCancelPress: () => {
                                                                    dispatch(close());
                                                                },
                                                            })
                                                        );                                                           
                                                    }}                    
                                                    styles={{ width: 80, height: 30, fontSize: 12 }}
                                                    buttonTxt={'삭제'}
                                                />
                                            </div>
                                            : 
                                            <>
                                                <div 
                                                    className={`${listClass}`}
                                                    style={{ cursor: 'pointer', whiteSpace: 'pre-wrap' }}
                                                >
                                                    {x[x2?.key]}
                                                </div>
                                            </>
                                            }
                                        </div>
                                    );
                                })}                                        
                                </div>  
                            );
                        })}
                        {productlistTd?.length === 0 &&
                            <div className='nolistArea'>
                                등록된 의뢰매물이 없습니다.
                            </div>                        
                        }
                        <div ref={target} style={{ width: '100%', height: 1 }} />
                    </div>
                </div>
            </div>
        </Layout>
        
        </>
    )
}
